import {
  collection,
  doc,
  getDocs,
  query,
  updateDoc,
  where,
} from "firebase/firestore";
import { db } from "../../firebase";

const UpdateUserInfo = async (Email) => {
  try {
    let userDoc = await collection(db, "users");
    const q = query(userDoc, where("email", "==", Email));
    userDoc = await getDocs(q);
    if (userDoc.docs.length === 0) return false;
    const docData = userDoc.docs[0].data();
    const { uid } = docData;
    const data = {
      ...docData,
      password_update_email_sent: false,
    };
    await updateDoc(doc(db, "users", uid), data);
    return uid;
  } catch (error) {
    console.log(error);
    return "";
  }
};

export default UpdateUserInfo;
